/** @jsx h */
import { h } from 'preact'
import { forwardRef } from 'preact/compat'
import clsx from 'clsx'
import { useGlobal } from '../use-global'

const Textarea = forwardRef(
  ({ id, label, value, hasError, onChange, placeholder, ariaPlaceholder, name, className }, ref) => {
    const [{ canvasConfig }] = useGlobal()
    return (
      <div className={clsx('rcc-relative rcc-mt-9', className)}>
        <label
          htmlFor={id}
          className={clsx('rcc-text-sm rcc-block rcc-mb-2.5', {
            'rcc-text-danger': hasError,
            'rcc-text-gray': !hasError,
            'rcc-text-right': canvasConfig.direction === 'rtl'
          })}
        >
          {label}
        </label>
        <textarea
          id={id}
          ref={ref}
          value={value}
          className={clsx(
            'textarea-component rcc-w-full rcc-h-[248px] mobile:rcc-h-[156px]  rcc-border rcc-placeholder-gray-light rcc-resize-none rcc-font-light rcc-px-4 rcc-py-3 md:rcc-p-5 rcc-text-sm',
            {
              [className]: !!className,
              'rcc-border-danger': hasError,
              'rcc-border-gray-light': !hasError,
              'rcc-text-right': canvasConfig.direction === 'rtl',
              'rcc-tracking-[1.68px]': canvasConfig.locale !== 'ar'
            }
          )}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          aria-placeholder={ariaPlaceholder}
          maxLength='250'
        ></textarea>
      </div>
    )
  }
)

export default Textarea
